export default {
    invoice_title:        "Platba na faktúru",
    invoice_info:         "Faktúru za služby PREMIUM na celý rok v hodnote 51,60 € ti pošleme v e-maili :)",
    invoice_info_pretlak: "Faktúru za služby PREMIUM na celý rok v hodnote 51,60 € (po zľave 43,90 €) ti pošleme v e-maili :)",
    billing_title:        "Fakturačné údaje",
    billing_note:         "Faktúru ti vystavíme na tieto údaje. Ak nemáš IČO, zadaj svoj trvalý pobyt.",
    company_type:         "Som firma, živnostník",
    personal_type:        "Som fyzická osoba",
    company_placeholder:  "Názov spoločnosti",
    company_label:        "Názov spoločnosti",
    ico_placeholder:      "IČO",
    ico_label:            "IČO",
    dic_placeholder:      "DIČ",
    dic_label:            "DIČ",
    icdph_placeholder:    "IČ DPH",
    icdph_label:          "IČ DPH",
    address_placeholder:  "Ulica a číslo",
    address_label:        "Ulica a číslo",
    psc_placeholder:      "PSČ",
    psc_label:            "PSČ",
    promo_placeholder:    "PROMO KÓD",
    promo_label:          "PROMO KÓD",
    terms_agree:          "Súhlasím so",
    terms_link:           "všeobecnými obchodnými podmienkami",
    order_btn:            "Objednať s povinnosťou platby",
    company_type_value:   "Firma / živnostník",
    personal_type_value:  "Fyzická osoba",

    // ThePayment
    payment_title:          "Platiť môžeš a nemusíš, je to na tebe",
    payment_subtitle:       "Ak ti už nestačí FREE verzia DOFFERO, môžeš prejsť na PREMIUM.",
    payment_premium_hint:   "Vyplň údaje nižšie a môžeš sa okamžite pustiť do vytvárania cenových ponúk v móde PREMIUM.",
    payment_leaving_title:  "Odchádzaš? :(",
    payment_leaving_hint:   "To nás mrzí. Daj nám prosím vedieť dôvod, aby sme sa mohli zlepšovať.",

    // PaymentThree
    p3_success:             "Skvelé! Od teraz si môžeš vychutnávať všetky výhody balíčka PREMIUM.",
    p3_downgraded:          "Tvoj balíček bol zmenený na DOFFERO FREE.",
    p3_invoice:             "Faktúru za ročný balíček PREMIUM ti pošleme na e-mail. Ďakujeme za skorú úhradu.",
    p3_go_offers:           "Prejsť na moje ponuky",

    // PaymentFour
    p4_reason_label:        "Aký je dôvod zrušenia DOFFERO PREMIUM?",
    p4_warning:             'Po kliknutí na tlačidlo "ZRUŠIŤ" nižšie Vám bude ihneď zmenený balíček na DOFFERO FREE.',
    p4_back_btn:            "Späť na balíčky",
    p4_cancel_btn:          "Zrušiť DOFFERO PREMIUM",
};